import React, { useState } from 'react';
import { Form, Row, Col, Label, Input, Button, Spinner, Card, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import { Btn, H3 } from '../../../AbstractElements';
import { postJson } from '../../../hook/request';

// opzionale: mappa valore select -> label
const OPTIONS = [
    { value: 'Clienteling', label: 'Clienteling' },
    { value: 'Anagrafe', label: 'Anagrafe' },
    { value: 'Modelli', label: 'Modelli' },
    { value: 'ProdottiVendite', label: 'Articoli Venduti' },
    { value: 'bolle', label: 'Bolle' },
];

export default function TemplateUploadForm() {
    const [tipo, setTipo] = useState<string>('');
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const f = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        setFile(f);
    };

    const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.warn('Seleziona un file da caricare');
            return;
        }

        const formData = new FormData();
        formData.append('file', file); 

        try {
            setLoading(true);
            const endpoint = '/files/template';
            formData.append('tipo', tipo);
            await postJson(endpoint, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            toast.success('File caricato correttamente');
            // reset
            setFile(null);
            (document.getElementById('formFile') as HTMLInputElement | null)?.value && ((document.getElementById('formFile') as HTMLInputElement).value = '');
        } catch (err: any) {
            toast.error(err?.message || 'Errore di rete');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-body pt-4">
            <Card>
                <CardBody>
                    <Col md={12}>
                        <H3>Template</H3>
                    </Col>
                    <Form onSubmit={onSubmit} className="mt-3">
                        <Row className="g-3 align-items-end">
                            <Col md={12}>
                                <Label htmlFor="tipo">Tipo</Label>
                                <Input
                                    id="tipo"
                                    type="select"
                                    value={tipo}
                                    onChange={(e) => setTipo(e.target.value)}
                                >
                                    <option key={0} value={''}>Scegli...</option>
                                    {OPTIONS.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Input>
                            </Col>

                            <Col md={12}>
                                <Label htmlFor="formFile">File</Label>
                                <Input
                                    id="formFile"
                                    type="file"
                                    accept="*/*"
                                    onChange={handleFileChange}
                                    required
                                />
                            </Col>

                            <Col md={2} className="d-grid">
                                <Btn color="primary" type="submit" disabled={loading || !file}>
                                    {loading ? <Spinner size="sm" /> : 'Carica'}
                                </Btn>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </div>

    );
}
